import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Using the Pluto Frame SDKs";
const frontMatter = {
  "title": "Using the Pluto Frame SDKs",
  "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
};
import FEATURE_FLAGS from "@/utils/featureFlags";
import JavascriptSdkExamples from "@/components/JavascriptSdkExamples";
export function useTOC(props) {
  return [{
    value: "Using the Pluto Frame SDKs",
    id: "using-the-pluto-frame-sdks",
    depth: 2
  }, {
    value: "Getting Started",
    id: "getting-started",
    depth: 3
  }, {
    value: "Choose Your Implementation",
    id: "choose-your-implementation",
    depth: 3
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.h3 id={toc[1].id}>{toc[1].value}</_components.h3>{"\n"}<_components.p>{"Pluto offers two npm packages to help you integrate the Pluto Frame into your application:"}</_components.p>{"\n"}<_components.p><_components.strong><_components.a href="https://www.npmjs.com/package/@plutoxyz/react-frame">{"@plutoxyz/react-frame"}</_components.a></_components.strong>{": For React applications"}<br />{"\n"}<_components.strong><_components.a href="https://www.npmjs.com/package/@plutoxyz/frame-js">{"@plutoxyz/frame-js"}</_components.a></_components.strong>{": For vanilla JavaScript applications"}</_components.p>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.p>{"Select your preferred implementation method below:"}</_components.p>{"\n"}{"\n"}<JavascriptSdkExamples /></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/guides/using-the-javascript-sdk',
  {"filePath":"pages/guides/using-the-javascript-sdk.mdx","timestamp":1750278560000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)